module.exports = __webpack_public_path__ + "static/img/banner5.1821809b.svg";